import { ChartKey, InstanceParams } from "charts/src/types/chart";

export const validateChart13FInstanceParams = ({
  chartKey,
  instanceParams,
}: {
  chartKey: ChartKey;
  instanceParams: InstanceParams;
}) => {
  switch (chartKey) {
    case "13f_investor_holding_cost":
      return (
        "investor" in instanceParams &&
        "symbol" in instanceParams &&
        !!instanceParams.investor &&
        !!instanceParams.symbol
      );
    case "13f_investor_holding_weights":
    case "13f_investor_industrial_distribution":
      return "investor" in instanceParams && !!instanceParams.investor;
    case "13f_symbol_capital_flow":
      return "symbol" in instanceParams && !!instanceParams.symbol;
    default:
      return false;
  }
};
